document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobiel menu ---------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var menuPanel = document.querySelector('[data-mobile-menu-panel]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', function () {
      menuPanel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('mobile-menu-open');
    });
  }
  if (menuClose && menuPanel) {
    menuClose.addEventListener('click', function () {
      menuPanel.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.classList.remove('mobile-menu-open');
    });
  }

  /* ---------- Zoeken (overlay + live productsuggesties) ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    window.setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 50);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  function formatCents(cents) {
    var value = parseFloat(cents) / 100;
    if (isNaN(value)) return '';
    return '€' + value.toFixed(2).replace('.', ',');
  }

  function withWidth(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function pickVariantImage(variant, product) {
    if (variant.featured_image) {
      return typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
    }
    if (product.featured_image) {
      return typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    }
    if (product.images && product.images.length) return product.images[0];
    return null;
  }

  function renderSearchSuggestions(items, q) {
    if (!items.length) {
      searchResults.innerHTML = '<p class="search-empty">Geen producten gevonden voor &ldquo;' + escapeHtml(q) + '&rdquo;.</p>';
    } else {
      var html = '<div class="search-suggestions">';
      items.forEach(function (item) {
        html += '<a href="' + item.url + '" class="search-suggestion">' +
          (item.image ? '<img src="' + withWidth(item.image, 120) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<span class="search-suggestion-noimg"></span>') +
          '<span class="search-suggestion-info">' +
          '<span class="search-suggestion-title">' + escapeHtml(item.title) + '</span>' +
          (item.variantNote ? '<span class="search-suggestion-variant">' + escapeHtml(item.variantNote) + '</span>' : '') +
          '<span class="search-suggestion-price">' + formatCents(item.price) + '</span>' +
          '</span></a>';
      });
      html += '</div>';
      searchResults.innerHTML = html;
    }
    searchResults.innerHTML += '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-view-all">Bekijk alle resultaten voor &ldquo;' + escapeHtml(q) + '&rdquo;</a>';
  }

  if (searchInput && searchResults) {
    var searchDebounce;
    var searchRequestId = 0;
    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchDebounce);
      searchDebounce = window.setTimeout(function () {
        var q = searchInput.value.trim();
        if (q.length < 2) {
          searchResults.innerHTML = '';
          return;
        }
        var thisRequestId = ++searchRequestId;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) return [];
            return Promise.all(products.map(function (p) {
              var base = p.url.split('?')[0];
              return fetch(base + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
            }));
          })
          .then(function (fullProducts) {
            if (thisRequestId !== searchRequestId) return;
            var items = [];
            (fullProducts || []).forEach(function (product) {
              if (!product) return;
              product.variants.forEach(function (variant) {
                if (items.length >= 8) return;
                var variantNote = variant.title !== 'Default Title' ? variant.title.replace(/ \/ /g, ' · ') : '';
                items.push({
                  url: product.url + '?variant=' + variant.id,
                  image: pickVariantImage(variant, product),
                  title: product.title,
                  variantNote: variantNote,
                  price: variant.price
                });
              });
            });
            renderSearchSuggestions(items, q);
          })
          .catch(function () { /* stil falen */ });
      }, 250);
    });
  }

  /* ---------- Accordions (FAQ + productpagina) ---------- */
  function setPeekHeight(item) {
    var answer = item.querySelector('.faq-answer');
    if (!answer) return;
    var full = answer.scrollHeight;
    var peek = Math.max(Math.round(full * 0.2), 40);
    answer.dataset.peekHeight = peek;
    answer.style.maxHeight = peek + 'px';
  }

  document.querySelectorAll('[data-peek]').forEach(setPeekHeight);

  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-accordion-item]');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      var group = item.closest('[data-accordion-group]');
      if (group && group.hasAttribute('data-accordion-single')) {
        group.querySelectorAll('[data-accordion-item]').forEach(function (el) {
          el.classList.remove('is-open');
          if (el.hasAttribute('data-peek')) {
            var otherAnswer = el.querySelector('.faq-answer');
            if (otherAnswer) otherAnswer.style.maxHeight = otherAnswer.dataset.peekHeight + 'px';
          }
        });
      }
      item.classList.toggle('is-open', !wasOpen);
      if (item.hasAttribute('data-peek')) {
        var answer = item.querySelector('.faq-answer');
        if (answer) {
          answer.style.maxHeight = item.classList.contains('is-open')
            ? answer.scrollHeight + 'px'
            : answer.dataset.peekHeight + 'px';
        }
      }
    });
  });

  /* ---------- Productgalerij (afbeeldingen, video en 3D-model) ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaId = thumb.getAttribute('data-media-id');

      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');

      document.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
        var isMatch = slide.getAttribute('data-media-id') === mediaId;
        slide.classList.toggle('active', isMatch);
        if (isMatch) {
          slide.scrollIntoView({ inline: 'start', block: 'nearest' });
        } else {
          var video = slide.querySelector('video');
          if (video) video.pause();
        }
      });
    });
  });

  /* ---------- Galerij: swipe-puntjes (mobiel) ---------- */
  var galleryMain = document.querySelector('.gallery-main');
  var galleryDots = document.querySelectorAll('[data-gallery-dot]');
  if (galleryMain && galleryDots.length) {
    galleryMain.addEventListener('scroll', function () {
      var visibleSlides = Array.prototype.slice.call(galleryMain.querySelectorAll('[data-gallery-slide]')).filter(function (s) {
        return !s.classList.contains('color-hidden') && !s.classList.contains('size-hidden');
      });
      var idx = Math.round(galleryMain.scrollLeft / (galleryMain.clientWidth || 1));
      galleryDots.forEach(function (dot) { dot.classList.remove('active'); });
      if (visibleSlides[idx]) {
        var activeMediaId = visibleSlides[idx].getAttribute('data-media-id');
        var matchDot = document.querySelector('[data-gallery-dot][data-media-id="' + activeMediaId + '"]');
        if (matchDot) matchDot.classList.add('active');
      }
    }, { passive: true });
  }

  /* ---------- Miniaturen: horizontaal scrollen met pijltjes ---------- */
  var thumbsWrap = document.querySelector('[data-gallery-thumbs-wrap]');
  if (thumbsWrap) {
    var thumbsTrack = thumbsWrap.querySelector('[data-gallery-thumbs-track]');
    var thumbsPrev = thumbsWrap.querySelector('[data-gallery-thumbs-prev]');
    var thumbsNext = thumbsWrap.querySelector('[data-gallery-thumbs-next]');

    var updateThumbsNav = function () {
      var hasOverflow = thumbsTrack.scrollWidth > thumbsTrack.clientWidth + 1;
      if (!hasOverflow) {
        thumbsPrev.hidden = true;
        thumbsNext.hidden = true;
        return;
      }
      thumbsPrev.hidden = thumbsTrack.scrollLeft <= 0;
      thumbsNext.hidden = thumbsTrack.scrollLeft + thumbsTrack.clientWidth >= thumbsTrack.scrollWidth - 1;
    };

    thumbsPrev.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: -thumbsTrack.clientWidth * 0.8, behavior: 'smooth' });
    });
    thumbsNext.addEventListener('click', function () {
      thumbsTrack.scrollBy({ left: thumbsTrack.clientWidth * 0.8, behavior: 'smooth' });
    });
    thumbsTrack.addEventListener('scroll', updateThumbsNav);
    window.addEventListener('resize', updateThumbsNav);
    updateThumbsNav();
  }

  /* ---------- Lightbox (productafbeeldingen) ---------- */
  var lightbox = document.querySelector('[data-lightbox]');
  if (lightbox) {
    var lightboxImg = lightbox.querySelector('[data-lightbox-image]');
    var lightboxIndex = 0;

    var getLightboxTriggers = function () {
      return Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-trigger]')).filter(function (t) {
        return !t.closest('.color-hidden') && !t.closest('.size-hidden');
      });
    };

    var openLightbox = function (index) {
      var triggers = getLightboxTriggers();
      if (!triggers.length) return;
      lightboxIndex = (index + triggers.length) % triggers.length;
      var trigger = triggers[lightboxIndex];
      lightboxImg.src = trigger.getAttribute('data-lightbox-src');
      lightboxImg.alt = trigger.getAttribute('alt') || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var lightboxPrevBtn = lightbox.querySelector('[data-lightbox-prev]');
      var lightboxNextBtn = lightbox.querySelector('[data-lightbox-next]');
      var hideNav = triggers.length <= 1;
      if (lightboxPrevBtn) lightboxPrevBtn.style.display = hideNav ? 'none' : '';
      if (lightboxNextBtn) lightboxNextBtn.style.display = hideNav ? 'none' : '';
    };

    var closeLightbox = function () {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = getLightboxTriggers().indexOf(trigger);
        openLightbox(index < 0 ? 0 : index);
      });
    });

    var lightboxClose = lightbox.querySelector('[data-lightbox-close]');
    var lightboxPrev = lightbox.querySelector('[data-lightbox-prev]');
    var lightboxNext = lightbox.querySelector('[data-lightbox-next]');
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { openLightbox(lightboxIndex - 1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { openLightbox(lightboxIndex + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') openLightbox(lightboxIndex - 1);
      if (e.key === 'ArrowRight') openLightbox(lightboxIndex + 1);
    });
  }

  /* ---------- Kleur- en maatkeuze: matcht een echte Shopify-variant ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantDataEl = productForm.querySelector('[data-product-json]');
    var variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    var variantIdInput = productForm.querySelector('[data-variant-id-input]');
    var addToCartBtn = productForm.querySelector('[data-add-to-cart]');
    var addToCartText = productForm.querySelector('[data-add-to-cart-text]');
    var optionGroups = productForm.querySelectorAll('[data-option-group]');

    function currentSelection() {
      var selection = [];
      optionGroups.forEach(function (group) {
        var position = parseInt(group.getAttribute('data-option-position'), 10);
        var active = group.querySelector('[data-option-swatch].selected');
        selection[position - 1] = active ? active.getAttribute('data-option-value') : null;
      });
      return selection;
    }

    function findMatchingVariant(selection) {
      return variants.find(function (variant) {
        var opts = [variant.option1, variant.option2, variant.option3];
        return selection.every(function (value, index) {
          return value === null || opts[index] === value;
        });
      });
    }

    function updateSwatchAvailability() {
      var selection = currentSelection();
      optionGroups.forEach(function (group) {
        var position = parseInt(group.getAttribute('data-option-position'), 10);
        group.querySelectorAll('[data-option-swatch]').forEach(function (swatch) {
          var testSelection = selection.slice();
          testSelection[position - 1] = swatch.getAttribute('data-option-value');
          var exists = variants.some(function (variant) {
            var opts = [variant.option1, variant.option2, variant.option3];
            return testSelection.every(function (value, index) {
              return value === null || opts[index] === value;
            });
          });
          swatch.classList.toggle('is-unavailable', !exists);
        });
      });
    }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function applyGalleryFilter(color, size) {
      var colorLc = (color || '').toLowerCase();
      var sizeKey = (size || '').toLowerCase().replace(/\s+/g, '');

      /* Maatfilter alleen gebruiken als er voor deze maat ook echt foto's zijn. */
      var useSizeFilter = false;
      if (sizeKey) {
        var slides = document.querySelectorAll('[data-gallery-slide][data-media-size]');
        for (var i = 0; i < slides.length; i++) {
          var slideSize = slides[i].getAttribute('data-media-size');
          var slideColor = slides[i].getAttribute('data-media-color') || '';
          if (slideSize === sizeKey && (slideColor === '' || slideColor === colorLc)) {
            useSizeFilter = true;
            break;
          }
        }
      }

      document.querySelectorAll('[data-media-color]').forEach(function (el) {
        var mediaColor = el.getAttribute('data-media-color');
        var mediaSize = el.getAttribute('data-media-size') || '';
        el.classList.toggle('color-hidden', mediaColor !== '' && mediaColor !== colorLc);
        el.classList.toggle('size-hidden', useSizeFilter && mediaSize !== '' && mediaSize !== sizeKey);
      });

      var activeSlide = document.querySelector('[data-gallery-slide].active');
      if (activeSlide && (activeSlide.classList.contains('color-hidden') || activeSlide.classList.contains('size-hidden'))) {
        var firstVisibleThumb = document.querySelector('[data-gallery-thumb]:not(.color-hidden):not(.size-hidden)');
        if (firstVisibleThumb) firstVisibleThumb.click();
      }
      if (typeof updateThumbsNav === 'function') updateThumbsNav();
    }

    function updateForSelection() {
      var selection = currentSelection();
      var match = findMatchingVariant(selection);
      if (!match) return;

      if (variantIdInput) variantIdInput.value = match.id;

      if (addToCartText) {
        addToCartText.textContent = match.available
          ? 'In winkelwagen — ' + formatMoney(match.price)
          : 'Uitverkocht';
      }
      if (addToCartBtn) addToCartBtn.disabled = !match.available;

      var kleurGroup = productForm.querySelector('[data-option-group][data-option-name="Kleur"]') ||
        productForm.querySelector('[data-option-group][data-option-name="Color"]');
      var maatGroup = productForm.querySelector('[data-option-group][data-option-name="Maat"]') ||
        productForm.querySelector('[data-option-group][data-option-name="Size"]');
      if (kleurGroup || maatGroup) {
        var activeKleur = kleurGroup ? kleurGroup.querySelector('[data-option-swatch].selected') : null;
        var activeMaat = maatGroup ? maatGroup.querySelector('[data-option-swatch].selected') : null;
        applyGalleryFilter(
          activeKleur ? activeKleur.getAttribute('data-option-value') : '',
          activeMaat ? activeMaat.getAttribute('data-option-value') : ''
        );
      }

      if (match.featured_media) {
        var mediaId = String(match.featured_media.id);
        var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
        if (thumb) thumb.click();
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);

      updateSwatchAvailability();
    }

    productForm.querySelectorAll('[data-option-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.classList.contains('is-unavailable')) return;
        var group = swatch.closest('[data-option-group]');
        if (group) {
          group.querySelectorAll('[data-option-swatch]').forEach(function (s) {
            s.classList.remove('selected');
          });
          var labelTarget = group.querySelector('[data-option-selected-value]');
          if (labelTarget) labelTarget.textContent = swatch.getAttribute('data-option-value');
        }
        swatch.classList.add('selected');
        updateForSelection();
      });
    });

    updateSwatchAvailability();

    var qtyInput = productForm.querySelector('[data-qty-input]');
    var qtyMinus = productForm.querySelector('[data-qty-minus]');
    var qtyPlus = productForm.querySelector('[data-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }
  }

  /* ---------- Kleur- en maatkeuze buiten het productformulier (bv. losse blokken) ---------- */
  document.querySelectorAll('[data-option-swatch]').forEach(function (swatch) {
    if (swatch.closest('[data-product-form]')) return;
    swatch.addEventListener('click', function () {
      var group = swatch.closest('[data-option-group]');
      if (group) {
        group.querySelectorAll('[data-option-swatch]').forEach(function (s) {
          s.classList.remove('selected');
        });
      }
      swatch.classList.add('selected');
    });
  });

  /* ---------- Sticky koopbalk ---------- */
  var stickyBar = document.querySelector('[data-sticky-buy-bar]');
  var buyRow = document.querySelector('[data-buy-row-anchor]');
  var waFloat = document.querySelector('.whatsapp-float');
  if (stickyBar && buyRow && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', show);
        if (waFloat) waFloat.classList.toggle('shifted', show);
      });
    }, { threshold: 0 });
    observer.observe(buyRow);
  }

  /* ---------- Collectiefilters (mobiel in-/uitklappen) ---------- */
  var filterToggles = document.querySelectorAll('[data-filter-toggle]');
  var filterSidebar = document.querySelector('[data-filter-sidebar]');
  var filterBackdrop = document.querySelector('[data-filter-backdrop]');
  if (filterToggles.length && filterSidebar) {
    var setFiltersOpen = function (open) {
      filterSidebar.classList.toggle('is-open', open);
      if (filterBackdrop) filterBackdrop.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    filterToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        setFiltersOpen(!filterSidebar.classList.contains('is-open'));
      });
    });
    if (filterBackdrop) {
      filterBackdrop.addEventListener('click', function () {
        setFiltersOpen(false);
      });
    }
  }

  /* ---------- Collectiefilters (filtert op variant-niveau, dus per kleur/maat) ---------- */
  var filterGrid = document.querySelector('[data-filter-grid]');
  if (filterGrid) {
    var filterItems = Array.prototype.slice.call(filterGrid.querySelectorAll('[data-filter-item]'));
    var filterCountEl = document.querySelector('[data-filter-count]');
    var filterEmptyEl = document.querySelector('[data-filter-empty]');
    var filterInputs = document.querySelectorAll('[data-filter-input]');
    var filterClearBtn = document.querySelector('[data-filter-clear]');
    var priceMinEl = document.querySelector('[data-filter-input="price-min"]');
    var priceMaxEl = document.querySelector('[data-filter-input="price-max"]');

    var tilePagination = document.querySelector('[data-tile-pagination]');
    var tilePageTotal = tilePagination ? parseInt(tilePagination.getAttribute('data-total-pages'), 10) : 1;
    var tilePagePrev = tilePagination ? tilePagination.querySelector('[data-tile-page-prev]') : null;
    var tilePageNext = tilePagination ? tilePagination.querySelector('[data-tile-page-next]') : null;
    var tilePageCurrentEl = tilePagination ? tilePagination.querySelector('[data-tile-page-current]') : null;
    var currentTilePage = 1;

    /* Paginanummer in de URL bijhouden, zodat je na het bekijken van een product
       op dezelfde pagina van het overzicht terugkomt in plaats van op pagina 1. */
    function readTilePageFromUrl() {
      var match = window.location.search.match(/[?&]tp=(\d+)/);
      if (!match) return 1;
      var page = parseInt(match[1], 10);
      if (!page || page < 1) return 1;
      return page > tilePageTotal ? tilePageTotal : page;
    }

    function writeTilePageToUrl() {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      if (currentTilePage > 1) {
        url.searchParams.set('tp', currentTilePage);
      } else {
        url.searchParams.delete('tp');
      }
      window.history.replaceState(null, '', url.toString());
    }

    currentTilePage = readTilePageFromUrl();

    function getCheckedValues(name) {
      var values = [];
      document.querySelectorAll('[data-filter-input="' + name + '"]:checked').forEach(function (el) {
        values.push(el.value);
      });
      return values;
    }

    function applyFilters() {
      var widths = getCheckedValues('width');
      var colors = getCheckedValues('color');
      var priceMin = priceMinEl && priceMinEl.value !== '' ? parseFloat(priceMinEl.value) : null;
      var priceMax = priceMaxEl && priceMaxEl.value !== '' ? parseFloat(priceMaxEl.value) : null;
      var anyFilterActive = widths.length > 0 || colors.length > 0 || priceMin !== null || priceMax !== null;
      var visibleCount = 0;

      filterItems.forEach(function (item) {
        var itemWidth = item.getAttribute('data-filter-width') || '';
        var itemColor = item.getAttribute('data-filter-color') || '';
        var itemPrice = parseFloat(item.getAttribute('data-filter-price') || '0');
        var itemPage = parseInt(item.getAttribute('data-page'), 10) || 1;
        var matches = true;

        if (widths.length && widths.indexOf(itemWidth) === -1) matches = false;
        if (colors.length && colors.indexOf(itemColor) === -1) matches = false;
        if (priceMin !== null && itemPrice < priceMin) matches = false;
        if (priceMax !== null && itemPrice > priceMax) matches = false;

        var onCurrentPage = anyFilterActive || itemPage === currentTilePage;

        item.style.display = (matches && onCurrentPage) ? '' : 'none';
        if (matches) visibleCount += 1;
      });

      if (filterCountEl) filterCountEl.textContent = visibleCount + ' producten';
      if (filterEmptyEl) filterEmptyEl.style.display = visibleCount === 0 ? 'block' : 'none';
      filterGrid.style.display = visibleCount === 0 ? 'none' : '';

      document.querySelectorAll('[data-filter-input="color"]').forEach(function (el) {
        var swatch = el.nextElementSibling;
        if (swatch) swatch.classList.toggle('selected', el.checked);
      });

      if (tilePagination) {
        tilePagination.style.display = anyFilterActive ? 'none' : '';
        if (tilePageCurrentEl) tilePageCurrentEl.textContent = currentTilePage;
        if (tilePagePrev) tilePagePrev.disabled = currentTilePage <= 1;
        if (tilePageNext) tilePageNext.disabled = currentTilePage >= tilePageTotal;
      }
    }

    if (tilePagePrev) {
      tilePagePrev.addEventListener('click', function () {
        if (currentTilePage <= 1) return;
        currentTilePage -= 1;
        applyFilters();
        writeTilePageToUrl();
        filterGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    if (tilePageNext) {
      tilePageNext.addEventListener('click', function () {
        if (currentTilePage >= tilePageTotal) return;
        currentTilePage += 1;
        applyFilters();
        writeTilePageToUrl();
        filterGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    applyFilters();

    filterInputs.forEach(function (input) {
      var eventName = input.type === 'number' ? 'input' : 'change';
      input.addEventListener(eventName, applyFilters);
    });

    if (filterClearBtn) {
      filterClearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        filterInputs.forEach(function (input) {
          if (input.type === 'checkbox') {
            input.checked = false;
          } else {
            input.value = '';
          }
        });
        applyFilters();
      });
    }
  }

  /* ---------- Snel toevoegen (productkaart op categoriepagina) ---------- */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-quick-add');
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
    });
  });

  /* ---------- Winkelwagenpagina: live bijwerken zonder herladen ---------- */
  var cartPage = document.getElementById('CartPage');
  if (cartPage) {
    var cartSectionWrap = cartPage.closest('[id^="shopify-section-"]');
    var cartSectionId = cartSectionWrap ? cartSectionWrap.id.replace('shopify-section-', '') : '';
    var cartBusy = false;

    var updateHeaderCartCount = function (count) {
      var badge = document.querySelector('[data-cart-count]');
      var icon = document.querySelector('[data-header-cart-icon]');
      if (count > 0) {
        if (!badge && icon) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.setAttribute('data-cart-count', '');
          icon.appendChild(badge);
        }
        if (badge) badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    };

    var refreshCartPage = function () {
      if (!cartSectionId) return Promise.resolve();
      return fetch('/cart?section_id=' + cartSectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartPage');
          var current = document.getElementById('CartPage');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
    };

    var changeLine = function (line, quantity) {
      if (cartBusy) return;
      cartBusy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateHeaderCartCount(cart.item_count);
          return refreshCartPage();
        })
        .catch(function () {})
        .then(function () {
          cartBusy = false;
        });
    };

    document.addEventListener('click', function (e) {
      var qtyGroup = e.target.closest('[data-cart-qty]');
      if (qtyGroup) {
        var input = qtyGroup.querySelector('[data-qty-input]');
        if (e.target.closest('[data-qty-minus]')) {
          var newVal = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
          input.value = newVal;
          changeLine(qtyGroup.getAttribute('data-line'), newVal);
        } else if (e.target.closest('[data-qty-plus]')) {
          var newVal2 = (parseInt(input.value, 10) || 1) + 1;
          input.value = newVal2;
          changeLine(qtyGroup.getAttribute('data-line'), newVal2);
        }
        return;
      }
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) changeLine(removeBtn.getAttribute('data-line'), 0);
    });

    document.addEventListener('change', function (e) {
      var input2 = e.target.closest('[data-cart-qty] [data-qty-input]');
      if (input2) {
        var group = input2.closest('[data-cart-qty]');
        var newVal3 = Math.max(0, parseInt(input2.value, 10) || 0);
        changeLine(group.getAttribute('data-line'), newVal3);
      }
    });
  }

  /* ---------- Reviews: volledige review tonen zonder de shop te verlaten ---------- */
  var reviewPopup = document.querySelector('[data-review-popup]');
  if (reviewPopup) {
    var reviewPopupQuote = reviewPopup.querySelector('[data-review-popup-quote]');
    var reviewPopupAuthor = reviewPopup.querySelector('[data-review-popup-author]');
    var reviewPopupAvatar = reviewPopup.querySelector('[data-review-popup-avatar]');
    var reviewPopupClose = reviewPopup.querySelector('[data-review-popup-close]');

    var closeReviewPopup = function () {
      reviewPopup.classList.remove('is-open');
      reviewPopup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-review-popup-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var quote = trigger.getAttribute('data-review-quote') || '';
        var author = trigger.getAttribute('data-review-author') || '';
        reviewPopupQuote.textContent = '“' + quote + '”';
        reviewPopupAuthor.textContent = author;
        reviewPopupAvatar.textContent = author.slice(0, 1).toUpperCase();
        reviewPopup.classList.add('is-open');
        reviewPopup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    if (reviewPopupClose) reviewPopupClose.addEventListener('click', closeReviewPopup);
    reviewPopup.addEventListener('click', function (e) {
      if (e.target === reviewPopup) closeReviewPopup();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && reviewPopup.classList.contains('is-open')) closeReviewPopup();
    });
  }

  /* ---------- Gerelateerde producten (Shopify recommendations) ---------- */
  document.querySelectorAll('[data-recommendations-container]').forEach(function (container) {
    var url = container.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var newContainer = html.querySelector('[data-recommendations-container]');
        if (newContainer && newContainer.innerHTML.trim()) {
          container.innerHTML = newContainer.innerHTML;
        }
      })
      .catch(function () { /* stil falen: sectie blijft leeg */ });
  });
});
